import React from 'react';

export default function ProcessingProgressBar({ percentage, status }) {
  const getColor = () => {
    if (status === 'Completado') return 'bg-slate-400';
    if (status === 'Listo para Venta') return 'bg-emerald-500';
    if (status === 'Cancelado') return 'bg-red-400';
    if (percentage >= 75) return 'bg-blue-500';
    if (percentage >= 40) return 'bg-amber-500';
    return 'bg-orange-500';
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-slate-500" style={{ fontFamily: '"JetBrains Mono", monospace' }}>
          {percentage}%
        </span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-1.5 overflow-hidden">
        <div
          className={`h-1.5 rounded-full transition-all duration-500 ${getColor()}`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
    </div>
  );
}